import { render, staticRenderFns } from "./EditPageInfo.vue?vue&type=template&id=3258f2ee"
import script from "./EditPageInfo.vue?vue&type=script&lang=js"
export * from "./EditPageInfo.vue?vue&type=script&lang=js"
import style0 from "./EditPageInfo.vue?vue&type=style&index=0&id=3258f2ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports